import layerContral from '@/utils/contral/layerContral'
export default {
  legends: {
    // 场景名字或者自定义图例
    'GK-GangKou': {
      car: {
        layers: ['GK-GangKou-car'],
        txt: 'car', // 图例组件显示的文字
        img: '/img/legend/普通摄像头.png', //图例组件显示的图片
        showLegend: false, // 是否在图例组件中显示
        checked: false,
      },
      person: {
        layers: ['GK-GangKou-person'],
        txt: 'person', // 图例组件显示的文字
        img: '/img/legend/普通摄像头.png', //图例组件显示的图片
        showLegend: false, // 是否在图例组件中显示
        checked: false,
      },
      ship: {
        layers: ['GK-GangKou-ship'],
        txt: 'ship', // 图例组件显示的文字
        img: '/img/legend/普通摄像头.png', //图例组件显示的图片
        showLegend: false, // 是否在图例组件中显示
        checked: false,
      },
      camera: {
        layers: ['GK-GangKou-camera'],
        txt: 'ship', // 图例组件显示的文字
        img: '/img/legend/普通摄像头.png', //图例组件显示的图片
        showLegend: false, // 是否在图例组件中显示
        checked: false,
      },
     
    },
  },
  cardName: {
    maritimeSafety: {
      name: 'maritimeSafety',
      meta: {
        cname: 'maritimeSafety'
      },
      legendConfig: 'GK-GangKou',
      legends: ['person','car','ship','camera'],
      sceneName: 'GK-GangKou', // ShenZhenL3 ShenZhenWan 
      cameraName: 'maritimeSafety',
      sceneWeather: 'Sunny',
      sceneTime: '11:00',
    },
    
  },
  ...layerContral
}